App.controller('PrivacypolicyCtrl', ['$scope', '$rootScope', '$stateParams', '$sce', '$state', '$http', function ($scope, $rootScope, $stateParams, $sce, $state, $http) {
    
    $scope.step = 'Polityka prywatności';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);
}]);